module.exports = __webpack_public_path__ + "../assets/img/12183624cd0eae1eb03e5506a5aab9d8.svg";